import { createElement } from "react";
import BrowserSlash from "@/assets/icons/other/browser-slash.svg?react";

export const BrowserSlashIcon = (props: React.SVGProps<SVGSVGElement>) => {
  return createElement(BrowserSlash, {
    ...props,
    style: {
      height: "12.5px",
      width: "12.5px",
      ...props.style,
    },
  });
};
